import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Claim, {
  CLAIM_COLOR,
  CLAIM_SIZE,
} from '@bit/gerenciatd.unifiedcomponents.claim';
import TextInfo, {
  COLOR,
  SIZE,
  FONT_TYPE,
  KIND_TEXT,
  ALIGN,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import Price, {
  PRICE_COLOR,
  PRICE_SIZE,
  PRICE_DECORATION,
} from '@bit/gerenciatd.unifiedcomponents.price';
import CardRadioButton from '../../CardRadioButton';
import { actions as fusionActions } from '../../../reducers/fusion';
import './Promo.scss';

const Promo = ({
  selectedProduct, group, isOpenHiredProduct, taggingInfo,
}) => {
  const { products } = useSelector(state => state.fusion);
  const dispatch = useDispatch();

  const handleSelection = (alias) => {
    if (isOpenHiredProduct) {
      dispatch(fusionActions.setProductHiredSelected(alias));
    } else {
      const result = { ...products };
      Object.keys(result.allProducts).forEach((groupKey) => {
        const groupObject = result.allProducts[groupKey];
        if (groupObject.id === group.id) {
          Object.keys(groupObject).forEach((productKey) => {
            const productObject = groupObject[productKey];
            if (productObject.product && productObject.product.alias === alias) {
              productObject.selected = true;
            } else if (productObject.product && productObject.product.alias) {
              productObject.selected = false;
            }
          });
        }
      });
      dispatch(fusionActions.setAllProducts(result));
    }
  }

  return (
    <ul>
      {Object.keys(group)
        .filter(eachProductKey => eachProductKey.includes('fusion'))
        .map((eachProductKey) => {
          let currentTaggingInfo = { ...taggingInfo };
          const productObject = group[eachProductKey];
          if (productObject.dataMap && productObject.dataMap.pvpTachado) {
            currentTaggingInfo = {
              ...currentTaggingInfo,
              componentProduct: `${productObject.product.name};${productObject.product.taxonomy}`,
            }
          }
          return (
            <CardRadioButton
              key={eachProductKey}
              isdefaultChecked={selectedProduct.product.alias === group[eachProductKey].product.alias}
              name="promo-selector"
              data={group[eachProductKey]}
              onChange={() => handleSelection(group[eachProductKey].product.alias)}
              taggingInfo={{
                ...currentTaggingInfo,
                componentContent: 'elegir-promo',
              }}
            >
              {group[eachProductKey].dataMap.finLegales && (
              <div className="promo-card-btn__claim">
                <Claim
                  bgColor={CLAIM_COLOR.PURPLE}
                  color={CLAIM_COLOR.WHITE}
                  label={`ESTA PROMOCIÓN TERMINA EL ${group[eachProductKey].dataMap.finLegales}`}
                  size={CLAIM_SIZE.SMALL}
                />
              </div>
              )}
              <div className="promo-card-btn__content-wrapper">
                <div className="promo-card-btn__info">
                  <TextInfo
                    text={group[eachProductKey].product.name}
                    kind={KIND_TEXT.PARAGRAPH}
                    align={ALIGN.LEFT}
                    color={COLOR.BLACK}
                    size={SIZE.CAPTION1}
                    fontType={FONT_TYPE.LIGHT}
                  />
                  {group[eachProductKey].recom.promoCode && (
                  <TextInfo
                    text={group[eachProductKey].dataMap.bandaPromo}
                    kind={KIND_TEXT.PARAGRAPH}
                    align={ALIGN.LEFT}
                    color={COLOR.GREY_5}
                    size={SIZE.CAPTION2}
                    fontType={FONT_TYPE.REGULAR}
                  />
                  )}
                </div>
                <div className="promo-card-btn__price-wrapper">
                  {group[eachProductKey].dataMap.pvpTachado ? (
                    <React.Fragment>
                      <Price
                        amount={group[eachProductKey].dataMap.pvpTachado}
                        unity={group[eachProductKey].dataMap.unidad}
                        color={PRICE_COLOR.GREY_4}
                        decoration={PRICE_DECORATION.LINE_THROUGH}
                        size={PRICE_SIZE.EMP_22}
                      />
                      <Price
                        amount={group[eachProductKey].dataMap.pvp}
                        unity={group[eachProductKey].dataMap.unidad}
                        color={PRICE_COLOR.EGG}
                        decoration="none"
                        size={PRICE_SIZE.EMP_18}
                      />
                    </React.Fragment>
                  ) : (
                    <Price
                      amount={group[eachProductKey].dataMap.pvp}
                      unity={group[eachProductKey].dataMap.unidad}
                      color={PRICE_COLOR.EGG}
                      decoration="none"
                      size={PRICE_SIZE.EMP_22}
                    />
                  )}
                </div>
              </div>
            </CardRadioButton>
          );
        })}
    </ul>
  );
};

export default Promo;
